import { utils } from '@/utils';
import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { ReadRequestOptions } from '../requestOptions';

type Response = {
  count: number;
};

export const getPartiallyRoutedOrdersCount = async (scope: RequestScope, options: ReadRequestOptions): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(scope).get<EndpointResponse<Response>>(
      'search/order/count?page=1&limit=100&q=*&status=partially_routed,pending&sort=created_at:-1',
      options
    );

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
